import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Spinner from '../../components/generics/Spinner';
import _ from 'lodash';
import queryString from 'query-string';
import ReactPaginate from 'react-paginate';

import ReportInvoices from '../../components/reports/ReportInvoices';
import Filter from '../../components/generics/Filter';
import ReportHeader from '../../components/generics/ReportHeader';
import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import {
  fetchInvoiceReport,
  fetchInvoiceReportSuccess,
  fetchInvoiceReportFailure,
  fetchInvoiceReportCSV,
  fetchInvoiceReportCSVSuccess,
  fetchInvoiceReportCSVFailure,
} from "../../store/reports/actions";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class ReportInvoicesContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      filterFrom: moment().subtract(1, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      searchVal: ''
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const searchVal = params.val ? params.val : undefined;

    // Fetch initial page
    this.setState({filterFrom, filterTo, searchVal}, () => {
      this.props.getInvoicesReport(this.state.page, this.state.filterFrom, this.state.filterTo, this.state.searchVal);
    });

    this.props.fetchInvoiceReportCSV(filterFrom, filterTo);
  }

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------


  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE}, () => {
        this.updateQueryString();
        this.searchRefresh(true);
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE}, () => {
        this.updateQueryString();
        this.searchRefresh(true);
    });
  };

  onSearchChange = (event) => {
    let searchVal = event.target.value ? event.target.value : '';
    this.setState({ searchVal, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  searchRefresh = (refreshCSV) => {
    this.props.getInvoicesReport(this.state.page, this.state.filterFrom, this.state.filterTo, this.state.searchVal);
    if (refreshCSV) {
      this.props.fetchInvoiceReportCSV(this.state.filterFrom, this.state.filterTo);
    }
  };

  updateQueryString = () => {
    let params = {};
    if (this.state.filterFrom){
      params.from = this.state.filterFrom;
    }
    if (this.state.filterTo){
      params.to = this.state.filterTo;
    }
    if (this.state.searchVal){
      params.val = this.state.searchVal;
    }
    this.props.history.push({
      search: queryString.stringify(params)
    })
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (!this.state.filterFrom || !this.state.filterTo){
        return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader title='Invoices Report' actionTitle='Export CSV'
                          actionClass='btn btn-primary m-0'
                          headers={['VendorName', 'DateDue', 'InvoiceNumber', 'Date', 'ItemDescription', 'Cost', 'Pack', 'Quantity', 'TotalQuantity', 'NetWeight', 'TotalPrice']}
                          csvData={this.props.invoiceReportCSV.invoiceCSV}
                          filename={`${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}.csv`}
                          csvLoading={this.props.invoiceReportCSV.loading}
            />
            <Filter
              searchLabel="Search Invoice"
              searchPlaceholder="Search by Number or Item Description"
              searchVal={this.state.searchVal}
              onSearchChange={this.onSearchChange}
              dateLabel="From Date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To Date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
            />
          </div>
          <ReportInvoices invoicesList={this.props.invoicesReport.invoices}/>
          {this.props.invoicesReport.pages > 1 &&
            <ReactPaginate pageCount={this.props.invoicesReport.pages}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={this.handlePageRequest}
                            initialPage={this.state.page-1}
                            disableInitialCallback={true}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            activeClassName="page-item active"
                            previousClassName="paginate_button previous"
                            nextClassName="paginate_button next"
                            disabledClassName="page-item disabled"
                            forcePage={this.state.page-1}/>
          }
          {this.props.invoicesReport.loading ? <Spinner /> : null}
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    invoicesReport: state.reports.invoicesReport,
    invoiceReportCSV: state.reports.invoiceReportCSV,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getInvoicesReport: (page, from, to, search='') => {
      dispatch(fetchInvoiceReport(page, from, to, search)).payload.then((response) => {
        dispatch(fetchInvoiceReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchInvoiceReportFailure(error));
      });
    },
    fetchInvoiceReportCSV: (from, to) => {
      dispatch(fetchInvoiceReportCSV(from, to)).payload.then((response) => {
        dispatch(fetchInvoiceReportCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchInvoiceReportCSVFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportInvoicesContainer));
